'use client'

import { AnimatePresence, motion } from 'motion/react'

interface AnalysisIndicatorProps {
  isAnalyzing: boolean
  className?: string
}

const DOT_DELAYS = [0, 0.15, 0.3]

export function AnalysisIndicator({
  isAnalyzing,
  className,
}: AnalysisIndicatorProps) {
  return (
    <AnimatePresence>
      {isAnalyzing && (
        <motion.div
          key="analysis-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
          className={`flex h-6 items-center justify-center gap-1.5 ${className ?? ''}`}
        >
          {DOT_DELAYS.map((delay, i) => (
            <motion.span
              key={i}
              className="bg-muted-foreground inline-block h-1 w-1 rounded-full"
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{
                duration: 0.9,
                delay,
                repeat: Infinity,
                ease: 'easeInOut',
              }}
            />
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
